import { trackingDocumentActionsSaga } from './trackDocumentActions.sagas';
import { trackingUploadJobActionsSaga } from './trackUploadJob.sagas';

export const trackingSagas = [trackingDocumentActionsSaga, trackingUploadJobActionsSaga];
